import type { EpgUiSession } from "$src/core/services/session-storage/types";

const defaultEpgUiSession: EpgUiSession = {
  selectedDateOffset: 0,
  userSelectedChannelId: null,
};

const isEpgUiSession = (value: unknown): value is EpgUiSession => {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  const offset = Reflect.get(value, "selectedDateOffset");
  const channelId = Reflect.get(value, "userSelectedChannelId");

  return (
    typeof offset === "number" &&
    (channelId === null || typeof channelId === "string")
  );
};

const parseEpgUiSession = (stored: unknown): EpgUiSession =>
  isEpgUiSession(stored) ? stored : defaultEpgUiSession;

export default parseEpgUiSession;
